import { useSuspenseQuery } from '@apollo/client';
import { Suspense, type FC } from 'react';
import { GET_USER_NAME } from './query';
import { Skeleton, Typography, type TypographyProps } from '@mui/material';
import ApolloErrorBoundary from '@components/ApolloErrorBoundary';

interface Props {
  userId?: number;
  showId?: boolean;
}

const Component: FC<Props & TypographyProps> = ({ userId, showId, ...typographyProps }) => {
  const { data } = useSuspenseQuery(GET_USER_NAME, {
    variables: userId != null ? { id: userId } : undefined,
  });
  return (
    <Typography variant="inherit" component="span" {...typographyProps}>
      {showId ? `${data.user.id} - ` : ''}
      {data.user.fullName}
    </Typography>
  );
};

const Fallback: FC<TypographyProps> = (props) => {
  return (
    <Skeleton variant="text" sx={{ display: 'inline', ...props }}>
      <Typography variant="inherit" component="span" {...props}>
        placeholder
      </Typography>
    </Skeleton>
  );
};

const UserNameSpan: FC<Props & TypographyProps> = (props) => {
  const { userId, ...typographyProps } = props;
  return (
    <ApolloErrorBoundary variant="section-alert">
      <Suspense fallback={<Fallback {...typographyProps} />}>
        <Component {...props} />
      </Suspense>
    </ApolloErrorBoundary>
  );
};

export default UserNameSpan;
